export const formatPrice = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

// CORREÇÃO: A função deve calcular o saldo baseado no valor COM desconto
export const calculateSaldoDevedor = (valorComDesconto: number, valorEntrada: number, valorFormaPagamento2: number): number => {
  return Math.max(0, valorComDesconto - valorEntrada - valorFormaPagamento2);
};

export const calculateValorComDesconto = (valorTotal: number, descontoPercentual: number): number => {
  const desconto = (valorTotal * descontoPercentual) / 100;
  return Math.max(0, valorTotal - desconto);
};

export const validateDuasFormas = (valor1: number, valor2: number, valorEsperado: number): boolean => {
  const soma = valor1 + valor2;
  return Math.abs(soma - valorEsperado) < 0.01; // Tolerância de 1 centavo
};


